import React from "react";
import "./styles.css";
import moment from "moment";

const FALLBACK_AVATAR =
  "https://fafen.org/wp-content/uploads/2023/01/dummy.jpg";

export const HomeProfileSection = ({ item }) => {
  const parsedMemberSince = item?.memberSince
    ? moment(item.memberSince, "DD/MM/YYYY").utc()
    : null;
  const memberSince =
    parsedMemberSince && parsedMemberSince.isValid()
      ? parsedMemberSince.format("YYYY-MM-DD")
      : null;

  const fullName = [item?.firstName, item?.lastName]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="profileSectionContainer">
      <div className="profileAvatarWrapper">
        <img
          className="profileAvatar"
          src={item?.avatar || FALLBACK_AVATAR}
          alt={fullName || "Profile photo"}
        />
      </div>

      <div className="profileInfo">
        {memberSince && (
          <span className="profileMemberSince">Member since {memberSince}</span>
        )}
        {fullName && <h1 className="profileName">{fullName}</h1>}
      </div>
    </div>
  );
};
